module.exports = __webpack_public_path__ + "media/images/mascot3-55e55c0c.svg";